import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import privateExamApi from "../../api/privateExamApi";
import "./PrivateExams.css";

const toIstText = (utcDate) =>
  new Intl.DateTimeFormat("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(new Date(utcDate));

const UserPrivateExams = () => {
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadExams = async () => {
    try {
      setLoading(true);
      setError("");
      const res = await privateExamApi.getMyExams();
      setExams(res.data?.exams || []);
    } catch (err) {
      setError(err?.message || "Failed to load private exams");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadExams();
  }, []);

  const grouped = useMemo(() => {
    const upcoming = exams.filter((e) => e.computedState === "UPCOMING");
    const ongoing = exams.filter((e) => e.computedState === "ONGOING");
    const completed = exams.filter((e) => e.computedState === "COMPLETED");
    return { upcoming, ongoing, completed };
  }, [exams]);

  const renderCard = (exam) => (
    <article key={exam.assignmentId} className={`private-exam-card ${exam.computedState.toLowerCase()}`}>
      <div className="private-exam-card-head">
        <h3>{exam.title}</h3>
        <span className={`private-state-badge ${exam.computedState.toLowerCase()}`}>{exam.computedState}</span>
      </div>
      <p>{exam.description}</p>
      <div className="private-exam-meta">
        <span>Level: {exam.level}</span>
        <span>Time: {exam.timeLimit} min</span>
        <span>Pass Marks: {exam.passMarks}</span>
        <span>Status: {exam.status}</span>
      </div>
      <div className="private-exam-time-window">
        <div>Start (IST): {toIstText(exam.startTime)}</div>
        <div>End (IST): {toIstText(exam.endTime)}</div>
      </div>
      <div className="actions-row">
        <Link to={`/private-exams/${exam.examId}`} className="private-exam-open-btn">
          Open Exam
        </Link>
      </div>
    </article>
  );

  return (
    <section className="private-exams-page">
      <header className="private-exams-header">
        <h2>My Private Exams</h2>
        <p>Only assigned exams are visible here. Access is allowed only in assigned IST time window.</p>
      </header>

      {loading ? <div className="private-state-card">Loading private exams...</div> : null}
      {error ? <div className="private-state-card private-error">{error}</div> : null}

      {!loading && !error ? (
        <>
          <div className="private-exam-section">
            <h3>Ongoing</h3>
            {grouped.ongoing.length ? grouped.ongoing.map(renderCard) : <div className="private-empty">No ongoing exams.</div>}
          </div>
          <div className="private-exam-section">
            <h3>Upcoming</h3>
            {grouped.upcoming.length ? grouped.upcoming.map(renderCard) : <div className="private-empty">No upcoming exams.</div>}
          </div>
          <div className="private-exam-section">
            <h3>Completed</h3>
            {grouped.completed.length ? grouped.completed.map(renderCard) : <div className="private-empty">No completed exams.</div>}
          </div>
        </>
      ) : null}
    </section>
  );
};

export default UserPrivateExams;
